/* Custom Slideshow JavaScript */
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector("#slider-unique");
  const slides = document.querySelectorAll("#slider-unique .slide");
  const prev = document.getElementById("prev-unique");
  const next = document.getElementById("next-unique");
  const indicatorsContainer = document.querySelector("#indicators-unique");
  const indicatorWrapper = document.createElement("div");
  indicatorWrapper.classList.add("indicator-wrapper");
  indicatorsContainer.appendChild(indicatorWrapper);
  let currentIndex = 0;

  function createIndicators() {
    const numIndicators = slides.length - 1; // Numero di indicatori uguale al numero di slide
    for (let i = 0; i < numIndicators; i++) {
      const indicator = document.createElement("span");
      indicator.classList.add("indicator");
      indicator.setAttribute("data-index", i);
      indicatorWrapper.appendChild(indicator);
    }
  }

  function updateIndicators() {
    const indicators = document.querySelectorAll(
      "#indicators-unique .indicator"
    );
    indicators.forEach((indicator, index) => {
      indicator.classList.remove(
        "left-1",
        "left-2",
        "left-3",
        "left-4",
        "right-1",
        "right-2",
        "right-3",
        "right-4",
        "active"
      );
      if (index === currentIndex) {
        indicator.classList.add("active");
      } else if (index === currentIndex - 1) {
        indicator.classList.add("left-1");
      } else if (index === currentIndex - 2) {
        indicator.classList.add("left-2");
      } else if (index === currentIndex - 3) {
        indicator.classList.add("left-3");
      } else if (index === currentIndex - 4) {
        indicator.classList.add("left-4");
      } else if (index === currentIndex + 1) {
        indicator.classList.add("right-1");
      } else if (index === currentIndex + 2) {
        indicator.classList.add("right-2");
      } else if (index === currentIndex + 3) {
        indicator.classList.add("right-3");
      } else if (index === currentIndex + 4) {
        indicator.classList.add("right-4");
      }
    });
    // Rimuove la classe active-centered e la riaggiunge per l'attivo
    indicatorWrapper.classList.remove("active-centered");
    setTimeout(() => {
      indicatorWrapper.classList.add("active-centered");
    }, 0);
  }

  function showSlide(index) {
    slider.style.transform = `translateX(-${index * 50}%)`; // Sposta di 50% per mostrare due prodotti alla volta
    updateIndicators();
  }

  if (slider && prev && next && indicatorsContainer) {
    createIndicators();
    updateIndicators();

    prev.addEventListener("click", function () {
      currentIndex = currentIndex > 0 ? currentIndex - 1 : slides.length - 2;
      showSlide(currentIndex);
    });

    next.addEventListener("click", function () {
      currentIndex = currentIndex < slides.length - 2 ? currentIndex + 1 : 0;
      showSlide(currentIndex);
    });

    indicatorWrapper.addEventListener("click", function (event) {
      if (event.target.classList.contains("indicator")) {
        currentIndex = parseInt(event.target.getAttribute("data-index"));
        showSlide(currentIndex);
      }
    });

    // Prevent focus on arrow buttons
    prev.addEventListener("mousedown", function (e) {
      e.preventDefault();
    });
    next.addEventListener("mousedown", function (e) {
      e.preventDefault();
    });
  } else {
    console.error("Slideshow elements not found");
  }
});
